import React from 'react';
import { motion } from 'framer-motion';
const benefits = [{
  emoji: '🚀',
  title: 'Resultados Clínicos Superiores',
  desc: 'Al tener materiales claros y estructurados, tus pacientes implementan mejor, cumplen más y llegan al siguiente control con avances reales.'
}, {
  emoji: '😊',
  title: 'Fin de los Mensajes Fuera de Horario',
  desc: 'Cuando el material es claro, el paciente no necesita preguntarte todo. Menos WhatsApps a las once de la noche. Más tranquilidad para vos.'
}, {
  emoji: '💰',
  title: 'Consultorio que Justifica Honorarios Más Altos',
  desc: 'Un profesional que entrega material premium puede cobrar más caro con total confianza. El valor percibido sube desde la primera consulta.'
}, {
  emoji: '💪',
  title: 'Profesional Seguro y Respaldado',
  desc: 'Cada protocolo está basado en guías internacionales actualizadas. Entregás con la seguridad de que cada indicación tiene evidencia detrás.'
}];
export function BenefitsSection() {
  return <section className="py-12 md:py-16 bg-white" data-id="element-2">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-3">
        <div className="text-center mb-10" data-id="element-4">
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-slate-900 mb-4" data-id="element-5">
            EL IMPACTO REAL EN TU CONSULTORIO
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto" data-id="element-6">
            Esto es lo que realmente vas a lograr implementando el Masterpack.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 gap-8" data-id="element-7">
          {benefits.map((b, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-slate-50 border border-slate-100 p-8 rounded-3xl shadow-sm" data-id="element-8">
              <div className="text-4xl mb-4" data-id="element-9">{b.emoji}</div>
              <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-10">
                {b.title}
              </h3>
              <p className="text-slate-600 leading-relaxed" data-id="element-11">{b.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}